export enum ModuleType {
  CLICKANDCOLLECT = 0,
  TAKEAWAY = 1,
  ORDERATTABLE = 2,
  OPERATIONS = 3,
  KIOSK = 4,
  LANDINGPAGE = 5,
  FASTTRACK = 6,
  ROOMSERVICE = 7,

  EVENT = 10,
}
